import {
  Box, Image, ListItem, StatusBadge, Text,
} from '@domain-group/suit-theme'

import useCampaignComparable, { useCampaignComparableImage } from '@hooks/useCampaignComparable'

import { CampaignComparableModel } from '@models/types'

import defaultImageUrl from '../../assets/default-comparable.png'

const getStatusText = (saleMethod: string, sold: boolean) => {
  if (saleMethod === 'rental') return 'For Rent'
  if (sold) return 'Sold'

  return 'For Sale'
}

interface CampaignComparableListItemProps {
  campaignComparable: CampaignComparableModel,
}

const CampaignComparableGridItem = (props: CampaignComparableListItemProps) => {
  const { campaignComparable } = props

  const {
    address,
    bathrooms,
    bedrooms,
    carparks,
    land_area,
    price_guide,
    property_type,
    sale_method,
    sale_type,
    sold,
    suburb_name,
  } = campaignComparable

  const landAreaInt = land_area ? parseInt(land_area, 10) : null

  const {
    callbacks: {
      createOrEditCampaignComparable,
    },
  } = useCampaignComparable(campaignComparable)

  const { imageUrl } = useCampaignComparableImage(campaignComparable)

  return (
    <Box
      flexDirection="column"
      onClick={() => createOrEditCampaignComparable()}
      marginBottom={0}
      style={{ cursor: 'pointer' }}
      variant="white"
    >
      <Image
        backgroundSize="cover"
        borderRadius="5px 5px 0 0"
        boxProps={{ backgroundColor: 'backgroundColor' }}
        height={200}
        placeholderUrl={defaultImageUrl}
        url={imageUrl}
      />

      <Box flexDirection="column">
        <ListItem
          boxProps={{ justifyContent: 'center', padding: 'large', minHeight: 86 }}
          flexDirection="column"
          showAngleIcon
        >
          <Text fontSize="small" variant="ellipsis">
            {`${address}, ${suburb_name}`}
          </Text>

          <Text fontSize="xsmall" color="bodyFontLightColor" marginTop="small">
            {`${bedrooms || 0} Bed | ${bathrooms || 0} Bath | ${carparks || 0} Car`}
          </Text>

          <Text fontSize="xsmall" color="bodyFontLightColor" marginTop="small">
            {property_type && `${property_type}`}
            {property_type && landAreaInt && ' - '}
            {landAreaInt && <>{landAreaInt}m&sup2;</>}
          </Text>
        </ListItem>

        <Box
          borderTop="1px solid"
          borderColor="lineColor"
          margin="auto"
          width="93%"
        />

        <Box
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          padding="large"
        >
          <Text color="bodyFontLightColor" fontSize="xsmall" variant="ellipsis">
            {sale_type && `${sale_type}`}
            {sale_type && price_guide && ' - '}
            {price_guide && price_guide}
          </Text>

          <StatusBadge
            color={sold ? 'green' : 'blue'}
            text={getStatusText(sale_method, sold)}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default CampaignComparableGridItem
